






































































































































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Notification, INotification } from "@/entities";

@Component
export default class MigrationListComponent extends Vue {
  placeholder: " ";
  dialog: boolean = false;
  dialogDelete: boolean = false;
  headers: any = [
    { text: "Programme", value: "Program" },
    { text: "Call", value: "Call" },
    { text: "Grant code", value: "GrantCode" },
    { text: "Grant status", value: "GrantStatus" },
    { text: "Import status", value: "ImportStatus" },
    { text: "Actions", value: "actions", sortable: false },
  ];
  items: any = [];
  search: string = "";
  editedIndex = -1;
  editedItem: any = {};
  defaultItem: any = {
    GrantCode: "",
  };
  dropdowns: any = {};
  importedStatusId: number = _app.migrationStatus.imported;

  mounted() {
    this.populateDropdowns();
    this.list();
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any) {
    if(changedRoute && changedRoute.name === 'Migrations') {
      this.populateDropdowns();
      this.list();
    }
  }

  get formTitle() {
    return this.editedIndex === -1
      ? this.$t("Add migration details")
      : this.$t("Edit migration details");
  }

  populateDropdowns() {
    return this.$services.migration.populateDropdowns().then((resp) => {
      this.dropdowns.programs = resp.Programs;
      this.dropdowns.calls = resp.Calls;
      this.dropdowns.grantStatus = resp.GrantStatus;
      this.dropdowns.programOfficers = resp.ProgramOfficers;
    });
  }

  filterCalls(programId: number) {
    this.populateDropdowns();

    // Filter calls by program
    this.dropdowns.calls = this.dropdowns.calls.filter(
      (x) => x.RelationId == programId
    );
  }

  list() {
    return this.$services.migration.list().then((resp) => {
      this.items = resp;
    });
  }

  editItem(item) {
    this.editedIndex = this.items.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.editedItem["GrantStatus"] = null;
    this.dialog = true;
  }

  deleteItem(item) {
    this.editedIndex = this.items.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialogDelete = true;
  }

  deleteItemConfirm() {
    this.$services.migration
      .delete(this.editedItem["MigrationImportId"])
      .then((resp: any) => {
        if (resp.status && resp.status >= 400) {
          let message = "";

          if (Array.isArray(resp.data)) {
            message = resp.data.join("<br/ >");
          } else {
            message =
              resp.status == 401 || resp.status == 403
                ? this.$t("User does not have permission")
                : resp.data;
          }

          this.$store.commit(
            "application/setNotification",
            new Notification({
              snack: true,
              isHtml: true,
              text: message,
              color: "error",
            } as INotification),
            { root: true }
          );
        } else {
          this.$store.commit(
            "application/setNotification",
            new Notification({
              snack: true,
              isHtml: true,
              text: this.$t("Record deleted"),
              color: "success",
            } as INotification),
            { root: true }
          );
        }

        this.list();
      });

    this.closeDelete();
  }

  importItem(item) {
    this.$router.push({
      name: "Migration",
      params: { id: item.MigrationImportId, statusId: item.WorkFlowStatusId },
    });
  }

  close() {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  closeDelete() {
    this.dialogDelete = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  save() {
    if (this.editedIndex > -1) {
      this.$services.migration.update(this.editedItem).then((resp: any) => {
        if (resp.status && resp.status >= 400) {
          let message = "";

          if (Array.isArray(resp.data)) {
            message = resp.data.join("<br/ >");
          } else {
            message =
              resp.status == 401 || resp.status == 403
                ? this.$t("User does not have permission")
                : resp.data;
          }

          this.$store.commit(
            "application/setNotification",
            new Notification({
              snack: true,
              isHtml: true,
              text: message,
              color: "error",
            } as INotification),
            { root: true }
          );
        } else {
          this.$store.commit(
            "application/setNotification",
            new Notification({
              snack: true,
              isHtml: true,
              text: this.$t("Record updated"),
              color: "success",
            } as INotification),
            { root: true }
          );
        }

        this.list();
      });
    } else {
      this.$services.migration.create(this.editedItem).then((resp: any) => {
        if (resp.status && resp.status >= 400) {
          let message = "";

          if (Array.isArray(resp.data)) {
            message = resp.data.join("<br/ >");
          } else {
            message =
              resp.status == 401 || resp.status == 403
                ? this.$t("User does not have permission")
                : resp.data;
          }

          this.$store.commit(
            "application/setNotification",
            new Notification({
              snack: true,
              isHtml: true,
              text: message,
              color: "error",
            } as INotification),
            { root: true }
          );
        } else {
          this.$store.commit(
            "application/setNotification",
            new Notification({
              snack: true,
              isHtml: true,
              text: this.$t("Record created"),
              color: "success",
            } as INotification),
            { root: true }
          );
        }

        this.list();
      });
    }

    this.close();
  }
}
